import { render, staticRenderFns } from "./CaseDiffTool.vue?vue&type=template&id=bdbbafd8&scoped=true&"
import script from "./CaseDiffTool.vue?vue&type=script&lang=js&"
export * from "./CaseDiffTool.vue?vue&type=script&lang=js&"
import style0 from "./CaseDiffTool.vue?vue&type=style&index=0&id=bdbbafd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbbafd8",
  null
  
)

export default component.exports